const getOriginalDisplayIdFromDuplicated = (duplicatedDisplayId: string): string => {
  return parseInt(duplicatedDisplayId, 10).toString();
};

export default getOriginalDisplayIdFromDuplicated;
